<div class="card monsido-panel mt-3 mx-3">
  <div class="card-header">
    <h3 class="font-weight-300">Validate Data</h3>
  </div>
  <div class="card-body">
    <p class="step-description">Review validation results before proceeding with the import.</p>

    <div class="validation-summary">
      <div class="summary-card">
        <div class="summary-label">Total Rows</div>
        <div class="summary-value">{{ data.length }}</div>
      </div>
      <div class="summary-card success">
        <div class="summary-label">Valid Rows</div>
        <div class="summary-value">{{ validRows.length }}</div>
      </div>
      @if (invalidRows.length > 0) {
        <div class="summary-card error">
          <div class="summary-label">Invalid Rows</div>
          <div class="summary-value">{{ invalidRows.length }}</div>
        </div>
      }
    </div>

    @if (exampleRow) {
      <div class="example-section">
        <h6>Example Check (Row {{ exampleRow.rowNumber }})</h6>
        <div class="example-card">
          <div class="example-row">
            <span class="example-label">Database ID:</span>
            <span class="example-value">{{ exampleRow.id }}</span>
          </div>
          @if (exampleRow.name) {
            <div class="example-row">
              <span class="example-label">Name:</span>
              <span class="example-value">{{ exampleRow.name }}</span>
            </div>
          }
          @if (exampleRow.description) {
            <div class="example-row">
              <span class="example-label">Description:</span>
              <span class="example-value">{{ exampleRow.description }}</span>
            </div>
          }
          @if (exampleRow.friendly_name) {
            <div class="example-row">
              <span class="example-label">Friendly Name:</span>
              <span class="example-value">{{ exampleRow.friendly_name }}</span>
            </div>
          }
          @if (exampleRow.impact) {
            <div class="example-row">
              <span class="example-label">Impact:</span>
              <span class="example-value">{{ exampleRow.impact }}</span>
            </div>
          }
          @if (exampleRow.difficulty) {
            <div class="example-row">
              <span class="example-label">Difficulty:</span>
              <span class="example-value">{{ exampleRow.difficulty }}</span>
            </div>
          }
        </div>
      </div>
    }

    @if (invalidRows.length > 0) {
      <div class="errors-section">
        <h6>Validation Errors</h6>
        <p class="text-warning">The following rows have errors and will be skipped:</p>
        <div class="errors-list">
          @for (row of invalidRows; track row.rowNumber) {
            <div class="error-item">
              <div class="error-header">
                <strong>Row {{ row.rowNumber }}</strong>
                @if (row.id) {
                  <span class="text-muted">(ID: {{ row.id }})</span>
                }
              </div>
              <ul class="error-messages">
                @for (error of row.errors; track error) {
                  <li>{{ error }}</li>
                }
              </ul>
            </div>
          }
        </div>
      </div>
    }

    @if (!canProceed()) {
      <div class="alert alert-danger" role="alert">
        No valid rows to import. Please go back and fix the data.
      </div>
    }
  </div>
</div>
